import styled from "@mui/material/styles/styled";
import MuiTableCell, {
  TableCellProps as ITableCellProps,
} from "@mui/material/TableCell";

export type TableCellProps = ITableCellProps;

const TableCell = styled(MuiTableCell)(({ theme }) => ({
  color: theme.palette.shades.neutral[800],
  minWidth: "fit-content",
  whiteSpace: "nowrap",
}));

export default TableCell;
